module.exports = __webpack_public_path__ + "static/media/Bulbbul.70035b80.png";